var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 164,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99EED0",
    d: "M101.443 149.916c42.494-7.235 72.575-42.437 53.532-81.02-23.209-47.02-71.526-58.315-93.476-54.577-42.494 7.235-53.644 56.13-48.198 87.786 7.29 42.374 45.648 55.047 88.142 47.811Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF7E7",
    d: "M93.77 141.069c37.232 0 67.994-25.523 57.434-61.01-12.871-43.252-52.347-59.815-71.579-59.815-37.233 0-53.885 39.876-53.885 67.523 0 37.008 30.796 53.302 68.03 53.302Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66E6B8",
    d: "M72.724 101.593 55.051 83.98l-6.019 5.956 23.692 23.61 50.859-50.684-5.976-5.955-44.883 44.686Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00C07B",
    d: "M72.724 97.37 55.051 79.756l-6.019 5.955 23.692 23.61 50.859-50.683-5.976-5.956L72.724 97.37Z"
  })));
};
export default SvgCheck;